import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";
import { getUserName } from "services/httpServices";
import { getUserId } from "services/httpServices";
import { getLoggedIn } from "services/httpServices";
import { postMethod } from "services/httpServices";

const AddProduct = ({ closeModal, mode = "add", initialData = [] }) => {
  console.log({ mode})
  const [products, setProducts] = useState([
    {
      "categoryCode": "",
      "categoryName": "",
      "productName": "",
      "tradeUnit": "",
      "gstEligible": true,
    },
  ]);

  const [groupedCategories, setGroupedCategories] = useState({});
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);

  const DRAFT_KEY = "draftProducts";

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const res = await postMethod(
          "/api/Inventory/GetAllCategories",
          {},
          "post"
        );
        if (res?.status === 200) {
          const grouped = res.data.result.reduce((acc, item) => {
            if (!acc[item.categoryCode]) {
              acc[item.categoryCode] = {
                categoryName: item.categoryName,
                subcategories: [],
              };
            }
            if (
              !acc[item.categoryCode].subcategories.some(
                (sub) => sub.subCategoryCode === item.subCategoryCode
              )
            ) {
              acc[item.categoryCode].subcategories.push({
                subCategoryCode: item.subCategoryCode,
                subCategoryName: item.subCategoryName,
              });
            }
            return acc;
          }, {});
          setGroupedCategories(grouped);
        }
      } catch (err) {
        console.error("Failed to load categories", err);
      } finally {
        setLoading(false);
      }
    };

    const loadData = () => {
      if (mode === "update" && initialData.length) {
        setProducts(initialData);
      } else {
        const draft = localStorage.getItem(DRAFT_KEY);
        if (draft) {
          try {
            const parsed = JSON.parse(draft);
            if (Array.isArray(parsed)) {
              setProducts(parsed);
            }
          } catch (err) {
            console.error("Failed to parse draft", err);
          }
        }
      }
    };

    fetchCategories();
    loadData();
  }, []);

  const usedPairs = (currentIndex) =>
    products
      .filter((_, i) => i !== currentIndex)
      .map((p) => `${p.categoryCode}-${p.subCategoryCode}`);

  const getAvailableCategories = (index) => {
    const used = usedPairs(index);
    return Object.entries(groupedCategories).filter(([categoryCode, data]) =>
      data.subcategories.some(
        (sub) => !used.includes(`${categoryCode}-${sub.subCategoryCode}`)
      )
    );
  };

  const getAvailableSubcategories = (index, categoryCode) => {
    if (!categoryCode) return [];
    const used = usedPairs(index);
    const subcats = groupedCategories[categoryCode]?.subcategories || [];
    return subcats.filter(
      (sub) => !used.includes(`${categoryCode}-${sub.subCategoryCode}`)
    );
  };

  const handleCategoryChange = (index, e) => {
    const categoryCode = e.target.value;
    const updated = [...products];
    if (categoryCode) {
      updated[index].categoryCode = categoryCode;
      updated[index].categoryName =
        groupedCategories[categoryCode]?.categoryName || "";
      updated[index].subCategoryCode = "";
      updated[index].subCategoryName = "";
    } else {
      updated[index].categoryCode = "";
      updated[index].categoryName = "";
      updated[index].subCategoryCode = "";
      updated[index].subCategoryName = "";
    }
    setProducts(updated);
  };

  const handleSubCategoryChange = (index, e) => {
    const subCategoryCode = e.target.value;
    const updated = [...products];
    const categoryCode = updated[index].categoryCode;

    if (subCategoryCode && categoryCode) {
      const subcat = groupedCategories[categoryCode].subcategories.find(
        (sub) => sub.subCategoryCode === subCategoryCode
      );
      updated[index].subCategoryCode = subCategoryCode;
      updated[index].subCategoryName = subcat?.subCategoryName || "";
    } else {
      updated[index].subCategoryCode = "";
      updated[index].subCategoryName = "";
    }

    setProducts(updated);
  };

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const updated = [...products];
    updated[index][name] = value;
    setProducts(updated);
  };

  const validate = () => {
    const errs = products.map((p) => {
      const missing = [];
      if (!p.categoryCode) missing.push("Category");
      if (!p.productName) missing.push("Product Name");
      if (!p.tradeUnit) missing.push("Trade Unit");
      return missing.length > 0 ? `Missing fields: ${missing.join(", ")}` : null;
    });
    setErrors(errs);
    return errs.every((e) => e === null);
  };


  const handleAdd = () => {
    setProducts([
      ...products,
      {
        categoryCode: "",
        categoryName: "",
        productName: "",
        tradeUnit: "",
        gstEligible: true,
      },
    ]);
  };


  const handleRemove = (index) => {
    const copy = [...products];
    copy.splice(index, 1);
    setProducts(copy);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);

    const now = new Date().toISOString();
    const loggedInUserId = getUserId() || 0;
    const loggedInUserName = getUserName() || "Unknown User";
    const nowData = new Date();
    const seconds = String(nowData.getSeconds()).padStart(2, "0");
    const milliseconds = String(nowData.getMilliseconds())
      .padStart(3, "0")
      .slice(0, 2);
    const timeSuffix = `${seconds}${milliseconds}`;

    const payload = products.map((p) => ({
      id: p.id || 0,
      merchantId: 0,
      merchantUserId: loggedInUserId,
      categoryCode: p.categoryCode,
      categoryName: p.categoryName,
      productName: p.productName,
      tradeUnit: p.tradeUnit,
      gstEligible: p.gstEligible,
      createdAt: now,
      createdBy: loggedInUserName,
      updatedAt: now,
      updatedBy: loggedInUserName,
      isDeleted: false,
      isBlocked: false,
    }));

    const endpoint =
      mode === "update"
        ? "/api/Inventory/UpdateProductMasters"
        : "/api/Inventory/AddProductMasters";

    try {
      const response = await postMethod(endpoint, payload, "post");
      if (response?.status === 200) {
        alert(
          mode === "add"
            ? "Product(s) added successfully."
            : "Product(s) updated successfully."
        );
        localStorage.removeItem(DRAFT_KEY);
        closeModal();
      } else {
        alert("Failed to save products. Please try again.");
      }
    } catch (err) {
      console.error("Error saving products:", err);
      alert("An error occurred while saving the products.");
    } finally {
      setLoading(false);
    }
  };

  const handleSaveDraft = () => {
    localStorage.setItem(DRAFT_KEY, JSON.stringify(products));
    alert("Draft saved.");
  };

  const handleClearDraft = () => {
    localStorage.removeItem(DRAFT_KEY);
    alert("Draft cleared.");
  };

  return (
    <Card className="bg-secondary shadow">
      <CardHeader className="bg-white border-0">
        <Row className="align-items-center">
          <Col xs="8">
            <h3 className="mb-0">
              {mode === "update" ? "Update Products" : "Add Products"}
            </h3>
          </Col>
          <Col className="text-right" xs="4">
            <Button close onClick={closeModal} />
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        <Form onSubmit={handleSubmit}>
          <div className="table-responsive">
            <table className="table table-bordered align-middle">
              <thead className="thead-light">
                <tr>
                  <th>Category *</th>
                  <th>Product Name *</th>
                  <th>Trade Unit *</th>
                  <th>GST Eligible</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {products.map((product, index) => {
                  const availableCategories = getAvailableCategories(index);
                  const availableSubcategories = getAvailableSubcategories(
                    index,
                    product.categoryCode
                  );

                  return (
                    <tr key={index}>
                      <td>
                        <Input
                          type="select"
                          value={product.categoryCode}
                          onChange={(e) => handleCategoryChange(index, e)}
                        >
                          <option value="">Select</option>
                          {Object.entries(groupedCategories).map(([code, data]) => (
                            <option key={code} value={code}>
                              {data.categoryName}
                            </option>
                          ))}
                        </Input>
                      </td>
                      <td>
                        <Input
                          type="text"
                          name="productName"
                          value={product.productName}
                          onChange={(e) => handleChange(index, e)}
                        />
                      </td>
                      <td>
                        <Input
                          type="text"
                          name="tradeUnit"
                          value={product.tradeUnit}
                          onChange={(e) => handleChange(index, e)}
                        />
                      </td>
                      <td className="text-center">
                        <Input
                          type="checkbox"
                          checked={product.gstEligible}
                          onChange={(e) => {
                            const updated = [...products];
                            updated[index].gstEligible = e.target.checked;
                            setProducts(updated);
                          }}
                        />
                      </td>
                      <td className="text-center">
                        <Button
                          color="danger"
                          size="sm"
                          onClick={() => handleRemove(index)}
                          disabled={products.length === 1}
                        >
                          <i className="fas fa-trash"></i>
                        </Button>
                      </td>
                    </tr>

                  );
                })}
              </tbody>
            </table>
          </div>

          {errors.some((e) => e) && (
            <div className="mb-3">
              {errors.map(
                (err, idx) =>
                  err && (
                    <div key={idx} style={{ color: "red" }}>
                      Row {idx + 1}: {err}
                    </div>
                  )
              )}
            </div>
          )}

          <div className="d-flex justify-content-between mt-3">
            <div>
              {mode === "add" && (
                <Button color="primary" onClick={handleAdd} type="button">
                  <i className="fas fa-plus"></i>
                </Button>
              )}
            </div>
            <div>
              {mode === "add" && (
                <>
                  <Button
                    color="warning"
                    type="button"
                    onClick={handleSaveDraft}
                    className="mr-2"
                  >
                    Save Draft
                  </Button>
                  <Button
                    color="danger"
                    type="button"
                    onClick={handleClearDraft}
                    className="mr-2"
                  >
                    Clear Draft
                  </Button>
                </>
              )}
              <Button color="success" type="submit" disabled={loading}>
                {loading
                  ? "Loading..."
                  : mode === "update"
                    ? "Update"
                    : "Submit"}
              </Button>
            </div>
          </div>
        </Form>
      </CardBody>
    </Card>
  );
};

export default AddProduct;
